import React from "react";

/**
 * Componente que representa el contenido de un componente que se expanded y contrae, ej: combobox, select, dropdown, etc.
 * @param {Object} props - Propiedades del componente `Content`.
 * @param {ReactNode} props.children - Elementos secundarios renderizados dentro del contenido.
 * @param {number} props.maxHeight - Altura máxima del contenido.
 * @param {string} props.maxWidth - Ancho máximo del contenido.
 * @param {boolean} props.relative - Indica si la posición css del contenido es relativa.
 * @returns {JSX.Element} Elemento JSX que representa el componente `Content`.
 */
export const Content = ({  ref, children, maxHeight, maxWidth, relative }) => {
	return (
		<div
			className={`list-wrapper ${relative ? "relative" : "absolute"}`}
			ref={ref}
			style={{
				maxHeight: maxHeight ? maxHeight : 200,
				maxWidth: maxWidth ? maxWidth : "100%",
			}}
		>
			{children}
		</div>
	);
};
